import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '@lib/components/common/Button';
import buildResourcePath from '@lib/buildResourcePath';

export default class ResultOfTransformToProductionOrderModal extends React.Component {

    onCloseClick = () => {
        window.location.reload();
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onCloseClick}>
                <Modal.Header>{__('Result of transform to production order')}</Modal.Header>
                <Modal.Body>
                    <ul>
                        {this.props.result.map(x => (
                            <li style={{padding: '5px'}}>
                                <a href={buildResourcePath(`/Project/Edit/${x.id}`)}>{x.number}</a>
                            </li>
                        ))}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.onCloseClick}>{__('Close')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}